import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar, MapPin, Bike } from 'lucide-react';
const BookingSearchModule = () => {
  const [camping, setCamping] = useState('');
  const [bikeType, setBikeType] = useState('');
  return <Card className="bg-white rounded-2xl shadow-xl border-0 max-w-4xl mx-auto -mt-8 relative z-10">
      
    </Card>;
};
export default BookingSearchModule;